export const PRESET_ROLE_LABELS = {
  en: {
    "Yazılımcı": "Developer",
    "Pazarlama": "Marketing",
    "İnsan Kaynakları": "Human Resources",
    "Satış": "Sales",
    "Tasarım": "Design",
    "Yönetici": "Manager",
    "Finans": "Finance",
    "Müşteri Destek": "Customer Support",
    "Operasyon": "Operations",
    "Ürün Yöneticisi": "Product Manager",
  },
};

export const translations = {
  tr: {
    nav: { login: "Giriş Yap", cta: "Ücretsiz Başla" },
    hero: {
      badge: "Yapay Zekâ Destekli İç İletişim",
      title1: "Herkes kendi dilinde",
      title2: "aynı şeyi anlasın.",
      desc: "Yazılımcı teknik yazsın, İK kendi diliyle okusun. alignee her mesajı okuyanın rolüne göre anında uyarlar. Ekipler arası anlaşmazlık son bulur.",
      cta: "Şirketini Kur",
      secondary: "Davet Koduyla Katıl",
    },
    demo: {
      devWrote: "Yazılımcı yazdı:",
      devMsg: '"Prod\'da null pointer alıyoruz, hotfix deploy ettim."',
      hrRead: "İK böyle okudu:",
      hrMsg: '"Canlı sistemde bir hata vardı, hızlıca düzeltildi."',
    },
    feat: {
      translateTitle: "Role Göre Çeviri",
      translateDesc: "Her mesaj, okuyucunun uzmanlık alanına göre otomatik sadeleştirilir. Orijinali her zaman bir tık uzağında.",
      tenantTitle: "Şirkete Özel",
      tenantDesc: "Her şirket kendi izole çalışma alanına sahip. Davet koduyla ekibini davet et.",
      rolesTitle: "Rol Tanımlama",
      rolesDesc: "Hazır roller veya kendi rolün. Ekibin gerçek yapısını yansıt.",
      channelsTitle: "Kanallar & DM",
      channelsDesc: "Genel kanallar ve birebir mesajlaşma; hepsi akıllı uyarlamayla.",
    },
    banner: { title: "Departmanlar arası dil bariyerini kaldır.", cta: "Hemen Başla" },
    auth: {
      slogan: "Ekibin aynı dili konuşmasa bile, aynı şeyi anlasın.",
      sloganSub: "Rol bazlı akıllı mesajlaşma ile departmanlar arası iletişimi hizala.",
      back: "Anasayfa",
      welcomeBack: "Tekrar hoş geldin",
      createAccount: "Hesap oluştur",
      loginSub: "alignee hesabına giriş yap.",
      registerSub: "Birkaç saniyede başla.",
      google: "Google ile devam et",
      or: "veya",
      name: "Ad Soyad",
      namePh: "Adınız",
      email: "E-posta",
      emailPh: "ornek@sirket.com",
      password: "Şifre",
      login: "Giriş Yap",
      register: "Kayıt Ol",
      wait: "Lütfen bekleyin...",
      noAccount: "Hesabın yok mu? ",
      haveAccount: "Zaten hesabın var mı? ",
      toRegister: "Kayıt ol",
      toLogin: "Giriş yap",
    },
    onb: {
      logout: "Çıkış",
      wsTitle: "Çalışma alanı",
      wsSub: "Yeni bir şirket kur ya da davet koduyla katıl.",
      create: "Şirket Kur",
      join: "Ekibe Katıl",
      companyName: "Şirket adı",
      companyPh: "Acme A.Ş.",
      inviteCode: "Davet kodu",
      continue: "Devam Et",
      processing: "İşleniyor...",
      roleTitle: "Rolünü seç",
      roleSub: "Mesajlar rolüne göre uyarlanacak. Departmanını yansıtan bir rol seç.",
      customRole: "+ Kendi rolümü yazacağım",
      customRolePh: "Örn: Veri Bilimci",
      enterWs: "Çalışma Alanına Gir",
      saving: "Kaydediliyor...",
      selectRole: "Lütfen bir rol seçin",
    },
    ws: {
      channels: "Kanallar",
      dms: "Direkt Mesajlar",
      workspace: "Çalışma alanı",
      inviteCode: "Davet kodu:",
      inviteCopied: "Davet kodu kopyalandı",
      logout: "Çıkış Yap",
      newChannel: "Yeni kanal",
      channelName: "Kanal adı",
      channelPh: "pazarlama",
      create: "Oluştur",
      teamMembers: "Ekip üyeleri",
      noRole: "Rol yok",
      noOtherMembers: "Henüz başka üye yok. Davet kodunu paylaş.",
      selectChat: "Bir sohbet seç",
      noMessages: "Henüz mesaj yok",
      noMessagesSub: "İlk mesajı sen gönder. Herkes kendi rolüne göre okuyacak.",
      composerA: "Nasıl istersen öyle yaz — ",
      composerB: " kendi diliyle okuyacak...",
    },
    mb: { showAdapted: "Uyarlanmışı göster", showOriginal: "Orijinali Gör" },
    common: { copyright: "© 2026 alignee" },
  },
  en: {
    nav: { login: "Log In", cta: "Start Free" },
    hero: {
      badge: "AI-Powered Internal Communication",
      title1: "Everyone in their own language,",
      title2: "understands the same thing.",
      desc: "Let developers write technical, and HR read it in their own words. alignee instantly adapts every message to the reader's role. Cross-team miscommunication ends here.",
      cta: "Create Your Company",
      secondary: "Join with Invite Code",
    },
    demo: {
      devWrote: "A developer wrote:",
      devMsg: '"We\'re getting a null pointer in prod, I deployed a hotfix."',
      hrRead: "HR read it as:",
      hrMsg: '"There was a bug in the live system, it was fixed quickly."',
    },
    feat: {
      translateTitle: "Role-Based Translation",
      translateDesc: "Every message is automatically simplified for the reader's field of expertise. The original is always one click away.",
      tenantTitle: "Company-Isolated",
      tenantDesc: "Each company gets its own isolated workspace. Invite your team with an invite code.",
      rolesTitle: "Role Definition",
      rolesDesc: "Preset roles or your own. Reflect your team's real structure.",
      channelsTitle: "Channels & DM",
      channelsDesc: "Company channels and one-to-one messaging; all with smart adaptation.",
    },
    banner: { title: "Break the language barrier between departments.", cta: "Get Started" },
    auth: {
      slogan: "Even if your team doesn't speak the same language, they understand the same thing.",
      sloganSub: "Align cross-department communication with role-based smart messaging.",
      back: "Home",
      welcomeBack: "Welcome back",
      createAccount: "Create account",
      loginSub: "Log in to your alignee account.",
      registerSub: "Get started in seconds.",
      google: "Continue with Google",
      or: "or",
      name: "Full Name",
      namePh: "Your name",
      email: "Email",
      emailPh: "you@company.com",
      password: "Password",
      login: "Log In",
      register: "Sign Up",
      wait: "Please wait...",
      noAccount: "Don't have an account? ",
      haveAccount: "Already have an account? ",
      toRegister: "Sign up",
      toLogin: "Log in",
    },
    onb: {
      logout: "Log out",
      wsTitle: "Workspace",
      wsSub: "Create a new company or join with an invite code.",
      create: "Create Company",
      join: "Join a Team",
      companyName: "Company name",
      companyPh: "Acme Inc.",
      inviteCode: "Invite code",
      continue: "Continue",
      processing: "Processing...",
      roleTitle: "Choose your role",
      roleSub: "Messages will be adapted to your role. Pick a role that reflects your department.",
      customRole: "+ I'll enter my own role",
      customRolePh: "e.g. Data Scientist",
      enterWs: "Enter Workspace",
      saving: "Saving...",
      selectRole: "Please select a role",
    },
    ws: {
      channels: "Channels",
      dms: "Direct Messages",
      workspace: "Workspace",
      inviteCode: "Invite code:",
      inviteCopied: "Invite code copied",
      logout: "Log Out",
      newChannel: "New channel",
      channelName: "Channel name",
      channelPh: "marketing",
      create: "Create",
      teamMembers: "Team members",
      noRole: "No role",
      noOtherMembers: "No other members yet. Share the invite code.",
      selectChat: "Select a conversation",
      noMessages: "No messages yet",
      noMessagesSub: "Send the first message. Everyone reads it in their own role.",
      composerA: "Write however you like — ",
      composerB: " will read it in their own words...",
    },
    mb: { showAdapted: "Show adapted", showOriginal: "View Original" },
    common: { copyright: "© 2026 alignee" },
  },
};
